import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=75f48d95&"
import script from "./UiSelect.vue?vue&type=script&lang=js&"
export * from "./UiSelect.vue?vue&type=script&lang=js&"
import style0 from "./UiSelect.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiSelect.vue
// module id = 414
// module chunks = 0